import React, { useEffect, useState } from 'react';
import { Button, Divider } from 'antd';
import { useGlobalState } from '../GlobalState';
import PaymentOptionMarks from './PaymentOptionMarks';
import PaymentCountdownTimer from './PaymentCountdownTimer';
import PaymentForm from './PaymentForm';
import PaymentMethodDrawer from './PaymentMethodDrawer';
import useApplePay from './useApplePay';
import '../../assets/css/payment_page.css';
import '../../assets/css/payment_form.css';
import { apiSlice } from '../../../../store/apiSlice';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { useReevaluateEngagementMutation } from '../../../user_profile/userProfileSlice';

function PaymentPage({
  idField,
  amount,
  enableStoredCards = false,
  enableApplePay = false,
  enableSaveCard = false,
  onPaymentSuccess = () => {},
  setErrorPayment,
  onPaymentFailure = () => {},
  title = 'Payment',
  headerContent = null,
  paymentExpiryTime = null,
  onClickCountdownEndedBack = () => {},
  countdownEndedExpiryMessage = 'Your reserved slots have expired, please try again.',
  countdownEndedBackMessage = 'Back to booking page',
}) {
  const dispatch = useDispatch();
  const [storedCards] = useGlobalState('storedCards');
  const [storedCardsError] = useGlobalState('storedCardsError');
  const [paymentFormData] = useGlobalState('paymentFormData');
  const [triggerEngagementReevaluation] = useReevaluateEngagementMutation();

  const anyStoredCards = Boolean(
    (storedCards?.length || storedCardsError) && !paymentFormData
  );
  const [showStoredCardsFooter, setShowStoredCardsFooter] = useState(
    enableStoredCards && anyStoredCards
  );

  const onPaymentSuccessInternal = () => {
    dispatch(apiSlice.util.invalidateTags(['CreditHistory']));
    axios.post('webhooks/trigger_pending');
    triggerEngagementReevaluation();
    onPaymentSuccess();
  };

  const [hasApplePay, applePayButton] = useApplePay({
    onSuccess: onPaymentSuccessInternal,
    onFailure: onPaymentFailure,
  });

  const showApplePay = hasApplePay && enableApplePay;

  useEffect(() => {
    window.scrollTo(0, 0);
    window.onbeforeunload = () => 'true';
    return () => (window.onbeforeunload = null);
  }, []);

  useEffect(() => {
    if (anyStoredCards) {
      setShowStoredCardsFooter(enableStoredCards && anyStoredCards);
    }
  }, [anyStoredCards, enableStoredCards]);

  const header = (
    <div className={'txt-center gRegular fs-16 mg-right-15 mg-left-15'}>
      <div className={'mg-bottom-10'}>
        <PaymentOptionMarks showApplePay={showApplePay} />
      </div>
      <h2 className={'gSemiBold fs-28'}>{title}</h2>
      {headerContent}
      {paymentExpiryTime && (
        <PaymentCountdownTimer
          paymentExpiryTime={paymentExpiryTime}
          onClickCountdownEndedBack={onClickCountdownEndedBack}
          expiryMessage={countdownEndedExpiryMessage}
          backMessage={countdownEndedBackMessage}
        />
      )}
    </div>
  );

  const changePaymentMethodButton = (
    <Button
      onClick={() => setShowStoredCardsFooter(true)}
      className='payment_form__button--inset txt-center br5 gSemiBold fs-18 w-full pd-7 pd-left-15 pd-right-15 h-full brFull mg-auto-lr text-wrap'
    >
      Change Payment Method
    </Button>
  );

  return (
    <div
      className={
        'pd-top-30 pd-left-25 pd-right-25 pd-bottom-20 display-flex-column justify-center'
      }
    >
      {header}
      {showApplePay && Boolean(applePayButton) && (
        <div className={'pd-bottom-15'}>{applePayButton}</div>
      )}
      {Boolean(storedCards?.length) && changePaymentMethodButton}
      <Divider className={'gRegular fs-15'}>
        {showApplePay && 'Or pay with card'}
      </Divider>
      <PaymentForm
        idField={idField}
        amount={amount}
        onPaymentSuccess={onPaymentSuccessInternal}
        onPaymentFailure={onPaymentFailure}
        enableSaveCard={enableSaveCard}
      />
      <PaymentMethodDrawer
        open={showStoredCardsFooter}
        setOpen={setShowStoredCardsFooter}
        setErrorPayment={setErrorPayment}
        showApplePay={showApplePay}
        amount={amount}
        onPaymentSuccess={onPaymentSuccessInternal}
        onPaymentFailure={onPaymentFailure}
      />
    </div>
  );
}

export default PaymentPage;
